export default __webpack_public_path__ + "static/media/logo.91a72264.png";